import React, { useState } from "react";

import PaginatedTable from "../../components/table";
import AddItem from "./components/addItem";

import { addRole, getRoles, deleteRole } from "./lib/roleData";
import { buildColumns } from "./lib/constants";
import { useNavigate } from "react-router-dom";

const RolesIndex = () => {
    const navigate = useNavigate();
    const [pulse, setPulse] = useState(false);

    const onTaskRowClick = (s, rowInfo, column, instance) => {
        return {
            onDoubleClick: (e) => {
                const url = `/admin/role/${rowInfo.original.id}`;
                navigate(url);
            },
        };
    };

    const deleteById = async (id) => {
        const response = await deleteRole(id);

        if (!response) {
            return;
        }

        triggerUpdate();
    };

    const triggerUpdate = () => {
        setPulse(!pulse);
    };

    return (
        <div>
            <h1>Roles</h1>
            <PaginatedTable getData={getRoles} columns={buildColumns(deleteById)} onTaskRowClick={onTaskRowClick} filterable={false} sortable={false} updatePulse={pulse} />
            <br />
            <h2>Add New Role</h2>
            <AddItem addText="Add Role" addItem={addRole} triggerUpdate={triggerUpdate} />
        </div>
    );
};

export default RolesIndex;
